<template>
    <div class="react-tabs__tab-panel" role="tabpanel">
        <ul class="list_items">
            <li v-for="l in tabData" :key="l">
                <ProductHardware :link="l"></ProductHardware>
            </li>
        </ul>
    </div>
</template>
<script>
import ProductHardware from './ProductHardware.vue';
export default {
    props: ["tabData"],
    mounted() {
        console.log(this.tabData);
    },
    components: {
        ProductHardware
    }
}
</script>